import { render, staticRenderFns } from "./SubstationControl.vue?vue&type=template&id=12c92e70&"
import script from "./SubstationControl.vue?vue&type=script&lang=js&"
export * from "./SubstationControl.vue?vue&type=script&lang=js&"
import style0 from "./SubstationControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports